import React, { useState, useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string } from "yup";
import { toast } from "react-toastify";

const validationSchema = object().shape({
  name: string().required("Medicine name is required"),
  type: string().required("Medicine type is required"),
});

export function EditMedicine() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const formik = useFormik({
    initialValues: {
      name: "",
      type: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        // Create FormData
        const formData = new FormData();
        formData.append("name", values.name.trim());
        formData.append("type", values.type.trim());

        const response = await axiosInstance.put(
          `/admin/master-medicine/${id}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.status === "success") {
          toast.success("Medicine updated successfully!");
          setTimeout(() => navigate("/medicine"), 1500);
        } else {
          toast.error(response.data.message || "Failed to update Medicine.");
        }
      } catch (err) {
        console.error("❌ Error updating Medicine:", err);
        toast.error("Something went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => {
    formik.resetForm();
    navigate("/medicine");
  };

  useEffect(() => {
    const fetchAdminDetails = async () => {
      try {
        const res = await axiosInstance.get(`/admin/master-medicine/${id}`);
        if (res.data.status === "success" && res.data.data) {
          formik.setValues({
            name: res.data.data.name || "",
            type: res.data.data.type || "",
          });
        } else {
          toast.error("Failed to load Medicine details.");
        }
      } catch (err) {
        console.error("Error fetching Medicine data:", err);
        toast.error("Something went wrong while loading Medicine data.");
      }
    };

    fetchAdminDetails();
  }, [id]);

  return (
    <div className="addAdmin-container">
      <div className="addAdmin-subcontainer">
        <IoIosArrowBack
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/medicine")}
        />
        <div className="add-title">Edit Medicine</div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="addAdmin-content">
          <div className="addAdmin-contentLeft">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Medicine Type
              </label>
              <div>
                <select
                  className="admin-type"
                  name="type"
                  value={formik.values.type}
                  onChange={formik.handleChange}
                >
                  <option value="">Select Medicine Type</option>
                  <option value="surgical">Surgical</option>
                  <option value="medicine">Medicine</option>
                </select>
                {formik.touched.type && formik.errors.type && (
                  <div className="text-danger">{formik.errors.type}</div>
                )}
              </div>
            </div>
          </div>
          <div className="addAdmin-contentRight">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span>Medicine Name
              </label>
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter Medicine Name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                />
                {formik.touched.name && formik.errors.name && (
                  <div className="text-danger">{formik.errors.name}</div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="addbtnContainer">
          <div>
            <button
              type="button"
              className="admin-btnCancel"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
          <div>
            <button className="add-btnSave">Update</button>
          </div>
        </div>
      </form>
    </div>
  );
}
